import copy from '../copy'

/**
 * @desc Navigates to the home (main marketing) page of the site
 */
export const navigateToHome = () => {
  window.location.href = copy().url
}
